import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

import { athleteGLMStatusKey } from './useAthleteGLMStatus';

/**
 * Remove the Kilo ↔ GLM link on both sides. On success invalidates the athlete
 * detail + athlete list + GLM status caches.
 */
export default function useUnlinkAthleteGLM(): UseMutationResult<
  AxiosResponse<null>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  return useMutation((athleteId: string) => client.post<null>(`athletes/${athleteId}/glm/unlink/`), {
    onSuccess: (_data, athleteId) => {
      queryClient.invalidateQueries(athleteGLMStatusKey(athleteId));
      queryClient.invalidateQueries('athletes');
    },
  });
}
